import React from 'react';
import { Box, Typography } from '@mui/material';
export default function EventCreative({ item, preview = false }) {
  return (
    <Box
      data-testid={preview ? 'event-preview' : undefined}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '18px',
        ...(preview ? { containerType: 'inline-size' } : {}),
      }}
    >
      <Box
        sx={{
          position: 'relative',
          aspectRatio: '14 / 9',
          backgroundColor: '#ddd',
          backgroundImage: `url("${item.imageUrl}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          ...(preview
            ? {
                '@container (max-width: 240px)': {
                  aspectRatio: 'auto',
                  minHeight: 280,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                },
              }
            : {}),
        }}
      >
        {(item.title.trim() || item.description.trim()) && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.12) 50%,rgba(0,0,0,.78))',
            }}
          />
        )}
        <Box
          sx={{
            position: 'absolute',
            left: 16,
            right: 16,
            bottom: 56,
            color: '#fff',
            ...(preview
              ? {
                  '@container (max-width: 240px)': {
                    position: 'relative',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                    px: 2,
                    pt: '72px',
                    pb: 1.5,
                  },
                }
              : {}),
          }}
        >
          {item.title.trim() && (
            <Typography
              noWrap
              sx={{
                color: '#FFFFFF',
                fontSize: 18,
                lineHeight: '24px',
                fontWeight: 600,
                letterSpacing: '-0.4px',
                transform: 'translateY(1px)',
                ...(preview
                  ? {
                      '@container (max-width: 240px)': {
                        whiteSpace: 'normal',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflowWrap: 'anywhere',
                      },
                    }
                  : {}),
              }}
            >
              {item.title}
            </Typography>
          )}
          {item.description.trim() && (
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: '17px',
                mt: item.title.trim() ? '3.5px' : 0,
                color: 'rgba(255,255,255,.8)',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                ...(preview
                  ? {
                      '@container (max-width: 240px)': {
                        WebkitLineClamp: 3,
                        overflowWrap: 'anywhere',
                      },
                    }
                  : {}),
              }}
            >
              {item.description}
            </Typography>
          )}
        </Box>
        {item.showAdMark && (
          <Box
            sx={{
              position: 'absolute',
              right: 16,
              top: 12,
              color: '#fff',
              fontSize: 10,
            }}
          >
            AD
          </Box>
        )}
      </Box>
      <Box
        data-testid={preview ? 'event-preview-action' : undefined}
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: '#F16438',
          color: '#fff',
          px: 2,
          height: 44,
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          ...(preview
            ? {
                '@container (max-width: 240px)': {
                  position: 'relative',
                  height: 'auto',
                  minHeight: 44,
                  py: 1,
                  '& > span:first-of-type': {
                    whiteSpace: 'normal !important',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflowWrap: 'anywhere',
                  },
                },
              }
            : {}),
        }}
      >
        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {item.actionLabel || '버튼 문구'}
        </span>
        <span style={{ flexShrink: 0 }}>›</span>
      </Box>
    </Box>
  );
}
